export const urls = {
  auth: 'oauth/token',
  document: 'document/',
  company: 'company/',
  course: 'course/',
  data: 'data/',
  employee: 'employee/',
  planning: 'planning/',
  planningEmployee: 'planningEmployee/',
  session: 'session/',
  sessionEmployee: 'sessionEmployee/',
  user: 'user/',
  cobidbService: 'cobidb-service/',
  contractualData: 'contractualDataController',
  consolidation: 'ConsolidationComponent',
  localCustomer: 'localCustomerController',
  localCustomerSettings: 'localCustomerSettingController',
  contractSetting: 'contractTypeSettingController',
  region: 'regionController',
  sl1: 'designServicesController',
  sl2: 'layerController',
  sl3: 'l1Controller',
  sl4: 'l2Controller',
  sl5: 'l3Controller',
  discount: 'discountController',
  units: 'unitsController',
  users: 'usersController',
  resourceUnits: 'resourceUnitController',
  serviceVariant: 'serviceVariantController',
  contractType: 'contractTypeController',
  provider: 'providerController',
  role: 'roleController',
  shareName: 'shareNameDeviceController',
  site: 'siteController',
  size: 'sizeController',
  roleAnagraf: 'roleRateCardController',
  rateType: 'rateTypeController',
  organizationUnit: 'organizationUnitController',
  currency: 'currencyController',
  currencySetting: 'currencySettingController',
  contract: 'contract/',
  architectureStructure : 'architectureStructureSettingController',
  contractController: 'contractController',
  terminationFeeController: 'terminationFeeController',
  reimbursmentController: 'reimbursmentController',
  transformationController: 'transformationController',
  rateCardController: 'rateCardController',
  consolidationController: 'consolidaController',
  minimumCommController: 'minimumCommitmentController',
  numAnnoMeseSetting: 'settingAnnoMeseController',
  chargingMethodology: 'chargingMethodologyController',
  expectedVolume: 'expectedVolumeController',
  serviceChanges: 'serviceChangesController',
  expectedVolumeDet: 'expectedVolumeDetController',
  deltaVolumi: 'deltaVolumiController',
  forecastVolumi: 'forecastVolumiController',
  deltaCharegs: 'deltaChargesController',
  deltaChargesDet: 'deltaChargesDetController',
  calculatedCharges: 'calculatedChargeController',
  calculatedChargeType: 'calculatedChargeTypeController',
  consuntivoVolumiScartoController: 'scartiConsultivoVolumiController',
  consuntivoChargesScartoController: 'scartiConsultivoChargesController',
  consuntivoVolumiController: 'consultivoVolumiController',
  consuntivoChargesController: 'consultivoChargesController',
  list: 'list',
  id: '{id}/',
  downloadXls: 'downloadXls/'
};

export function getHeaders() {
  const out = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
  };
  return out;
}

export const generalHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

export function getLoginHeaders() {
  const out = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Basic ' + btoa('web:web-secret')
  };
  return out;
}


